export default __webpack_public_path__ + "static/media/group_mobile.8c904064.png";